import { Box } from '@frontend/ui-library';
import { Currency } from '../CurrencySelection';
import { CurrencyOption } from './CurrencyOption';

export const CurrencyList = ({
  currencies,
  disabled,
  handleCurrencySelection,
}: {
  currencies: Currency[];
  disabled: boolean;
  handleCurrencySelection: (currency: string) => void;
}) => {
  return (
    <>
      {currencies.map((currency) => (
        <Box key={currency.symbol} mt="8">
          <CurrencyOption
            currency={currency}
            onSelect={handleCurrencySelection}
            disabled={disabled}
          />
        </Box>
      ))}
    </>
  );
};
